import { render, staticRenderFns } from "./AbfQuestionCompletionGauge.vue?vue&type=template&id=6a52ced6&scoped=true&"
import script from "./AbfQuestionCompletionGauge.vue?vue&type=script&lang=js&"
export * from "./AbfQuestionCompletionGauge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a52ced6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
